import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPaperPlane, faTrash } from '@fortawesome/free-solid-svg-icons';
import s from '../CaseFilePage.module.css';

interface PortalNote {
  id: number;
  created_at: string;
  author_name: string;
  body: string;
}

interface PortalNotesProps {
  portalNotes: PortalNote[];
  portalNoteText: string;
  setPortalNoteText: (v: string) => void;
  onPost: () => void;
  onDelete: (id: number) => void;
  isPostPending: boolean;
  fmtUKDate: (val: unknown) => string;
}

export default function PortalNotes({
  portalNotes,
  portalNoteText,
  setPortalNoteText,
  onPost,
  onDelete,
  isPostPending,
  fmtUKDate,
}: PortalNotesProps) {
  return (
    <div className={s.section}>
      <div className={s.sectionHeader}>
        <h3>
          <FontAwesomeIcon icon={faEnvelope} /> Portal Notes
        </h3>
        <span className={s.badge}>{portalNotes.length}</span>
      </div>
      <p style={{ fontSize: '0.82rem', color: 'var(--text-secondary)', margin: '0 0 12px' }}>
        Notes posted here are visible to the client in the Client Portal.
      </p>

      {/* Compose */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <textarea
          className={s.noteInput || ''}
          style={{
            flex: 1,
            minHeight: 60,
            resize: 'vertical',
            padding: 8,
            borderRadius: 6,
            border: '1px solid var(--border-primary, #d1d5db)',
            fontFamily: 'inherit',
            fontSize: '0.88rem',
            background: 'var(--input-bg)',
            color: 'var(--input-text)',
          }}
          placeholder="Write a note for the client…"
          value={portalNoteText}
          onChange={(e) => setPortalNoteText(e.target.value)}
        />
        <button
          className={s.actionBtn || ''}
          style={{
            alignSelf: 'flex-end',
            padding: '8px 16px',
            background: 'var(--primary-600, #2563eb)',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: '0.85rem',
            opacity: !portalNoteText.trim() || isPostPending ? 0.5 : 1,
          }}
          disabled={!portalNoteText.trim() || isPostPending}
          onClick={onPost}
        >
          <FontAwesomeIcon icon={faPaperPlane} /> Post
        </button>
      </div>

      {/* Notes list */}
      {portalNotes.length === 0 ? (
        <p className={s.emptyMsg}>No portal notes for this case.</p>
      ) : (
        <div className={s.tableScroll}>
          <table className={s.dataTable}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Author</th>
                <th>Note</th>
                <th style={{ width: 40 }}></th>
              </tr>
            </thead>
            <tbody>
              {portalNotes.map((pn) => (
                <tr key={pn.id}>
                  <td className={s.nowrap}>{fmtUKDate(pn.created_at)}</td>
                  <td className={s.nowrap}>{pn.author_name}</td>
                  <td style={{ whiteSpace: 'pre-wrap' }}>{pn.body}</td>
                  <td>
                    <button
                      className={s.iconBtn}
                      title="Delete portal note"
                      onClick={() => onDelete(pn.id)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
